var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mainVideo-wrapper"},[_c('MainVideo'),_c('About'),_c('OurBenefits'),_c('OpenAccount'),_c('Services'),_c('BankSecurity'),_c('OurCorporate'),_c('FeesAim'),_c('ApiGuide'),_c('ContactForm'),_c('Contact')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }